import { LandingPage } from '../LandingPage';
import { beautyConfig } from './config';

export default function BeautyLandingPage() {
  return <LandingPage config={beautyConfig} />;
}
